/**
 * Right-most column of the single-patient eligibility details screen.
 *
 * Holds the patient notes list beside the eligibility detail column.
 */
import PatientNotes from "./sidebar/PatientNotes";

/**
 * Patient notes column.
 *
 * @returns Right-most column section
 */
const ChatPanel = () => {
  return (
    <div className="single-patient-eligibility-details__chat w-1/4 overflow-hidden border-l border-primaryGray-14 bg-white">
      <PatientNotes />
    </div>
  );
};

export default ChatPanel;
